import { createContext } from "react";
import Stores from '../config/stores';


export const StoreContext = createContext(
    {
        stores: Stores,
        setStores: () => {},
    }
    );
